// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/change-password-modal/confirmation-modal.less
// module id = 4072
// module chunks = 0